import AbaTypeEnum from '~Api/WarehouseLoanTransactionAba/AbaTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

const abaTypeLabels: IDictionary<string> = {
    [AbaTypeEnum.FinRepaymentPrincipal]: 'FIN',
    [AbaTypeEnum.FinSalePrincipal]: 'FIN',
    [AbaTypeEnum.FitRepaymentPrincipal]: 'FIT',
    [AbaTypeEnum.FitSalePrincipal]: 'FIT',
    [AbaTypeEnum.FnomRepaymentPrincipal]: 'FNOM',
    [AbaTypeEnum.FnomSalePrincipal]: 'FNOM',
    [AbaTypeEnum.Fwt1PrefundPrepaidInterest]: 'FWT1',
    [AbaTypeEnum.Fwt1RepaymentPrincipal]: 'FWT1',
    [AbaTypeEnum.Fwt1SellInPrepaidInterest]: 'FWT1',
    [AbaTypeEnum.Fwt2PrefundPrepaidInterest]: 'FWT2',
    [AbaTypeEnum.Fwt2RepaymentPrincipal]: 'FWT2',
    [AbaTypeEnum.Fwt2SellInPrepaidInterest]: 'FWT2',
};

export default abaTypeLabels;